module.exports = __webpack_public_path__ + "img/check-document-tip.818115bd.svg";